export const matchSignoutCallback = (args) =>
  window?.location.href.startsWith(args.post_logout_redirect_uri);
